import { c as _c } from "react/compiler-runtime";
import { getOrgApiKeysQueryKey, patchOrgApiKeysByIdMutation } from '@onefootprint/fetch-dashboard';
import { useMutation, useQueryClient } from '@tanstack/react-query';
const useUpdateRoleId = () => {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = patchOrgApiKeysByIdMutation();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient) {
    t1 = {
      ...t0,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getOrgApiKeysQueryKey()
        });
      }
    };
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const mutation = useMutation(t1);
  return mutation;
};
export default useUpdateRoleId;